import { render } from "./Branches.vue?vue&type=template&id=0fd24619&scoped=true"
import script from "./Branches.vue?vue&type=script&lang=js"
export * from "./Branches.vue?vue&type=script&lang=js"

import "./Branches.vue?vue&type=style&index=0&id=0fd24619&lang=css"
import "./Branches.vue?vue&type=style&index=1&id=0fd24619&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd24619"]])

export default __exports__